/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestGenerateOtp, RequestValidateOtp, ResponseGenerateOtp, ResponseValidateOtp } from './message-service.types';


@Injectable({
    providedIn: 'root',
})
export class MessageService {
    private urlApi: string = environment.BASE_URL + 'otp/';

    constructor(private _httpClient: HttpClient) {}

    GenerateOtp(request: RequestGenerateOtp): Observable<ResponseGenerateOtp>{
        return this._httpClient.post<ResponseGenerateOtp>(this.urlApi + 'otp-send', request);
    }

    ValidateOtp(request: RequestValidateOtp): Observable<ResponseGenerateOtp>{
        return this._httpClient.post<ResponseValidateOtp>(this.urlApi + 'otp-validate', request);
    }
    generarOtpParaActualizacionDatosUsuario(request: RequestValidateOtp): Observable<ResponseGenerateOtp>{
        return this._httpClient.post<ResponseValidateOtp>(this.urlApi + 'opt-send-validate-data-update', request);
    }
    VerificarOptSctualizarDatosPersonales(request: RequestValidateOtp){
        return this._httpClient.post<ResponseValidateOtp>(this.urlApi + 'opt-validate-data-update', request);
    }
}
